import { IConfigData } from '@df/catalog/config/config.interfaces';
import { NICmsContentField } from '@icms/core/content';
import { ICmsContentService } from '@icms/core/content/icms-content.service';
export const CMS_CONFIG_NEWSLETTER = 'newsletter';
export interface IICmsConfigNewsletterDataContent extends IConfigData {
    emailNewsletterPreselection?: string;
}
export interface IICmsConfigNewsletterData extends IConfigData<IICmsConfigNewsletterDataContent> {}
ICmsContentService.registerConfig({
    id: CMS_CONFIG_NEWSLETTER,
    name: 'Newsletter configuration',
    fields: [
        <NICmsContentField.IChoiceField>{
            key: 'emailNewsletterPreselection',
            type: NICmsContentField.EFieldType.choice,
            title: 'Email newsletter preselection',
            options: [
                { key: 'none', title: 'None' },
                { key: 'all', title: 'All' },
                { key: 'checkoutOnly', title: 'Checkout only' }
            ],
            default: 'text',
            require: true
        }
    ]
});
